import { defineMessages } from 'react-intl';

export const messages: {
	betweenTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenTime: {
		id: 'proforma-form-renderer.common.utils.validators.time.between-time',
		defaultMessage: 'The time must be between {minimum, time, short} and {maximum, time, short}.',
		description: 'Validation message for field with time between a range.',
	},
	exactTime: {
		id: 'proforma-form-renderer.common.utils.validators.time.exact-time',
		defaultMessage: 'The time must be exactly {time, time, short}.',
		description: 'Validation message for field with exact time.',
	},
	invalidTime: {
		id: 'proforma-form-renderer.common.utils.validators.time.invalid-time',
		defaultMessage: 'The time is invalid.',
		description: 'Validation message for field with invalid time.',
	},
	maximumTime: {
		id: 'proforma-form-renderer.common.utils.validators.time.maximum-time',
		defaultMessage: 'The time must be at or before {maximum, time, short}.',
		description: 'Validation message for field with maximum time.',
	},
	minimumTime: {
		id: 'proforma-form-renderer.common.utils.validators.time.minimum-time',
		defaultMessage: 'The time must be at or after {minimum, time, short}.',
		description: 'Validation message for field with minimum time.',
	},
});
